var $ed6aae4e5f766f1e$exports = {};
$ed6aae4e5f766f1e$exports = {
  "Empty": "\u0641\u0627\u0631\u063A"
};
export { $ed6aae4e5f766f1e$exports as default };